exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.green-flag_green-flag_mk1Vo {\r\n    width: 2rem;\r\n    height: 2rem;\r\n    padding: 0.375rem;\r\n    border-radius: 0.25rem;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n    user-drag: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.green-flag_green-flag_mk1Vo:hover {\r\n    background-color: var(--looks-light-transparent);\r\n}\r\n\r\n.green-flag_green-flag_mk1Vo.green-flag_is-active_17xP9 {\r\n    background-color: var(--looks-transparent);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"green-flag": "green-flag_green-flag_mk1Vo",
	"greenFlag": "green-flag_green-flag_mk1Vo",
	"is-active": "green-flag_is-active_17xP9",
	"isActive": "green-flag_is-active_17xP9"
};